<script setup lang="ts">
import { computed } from 'vue'
import type { IPriceBoxProps } from '../types'
import { polishCurrencyTransformer } from '@/cms-ui/utils/polishCurrencyTransformer'
import { getPolishGenitive } from '@/cms-ui/utils/polishGenitivie'

const props = defineProps<IPriceBoxProps>()

const selected = computed(() =>
    props.installments?.find(installment => installment.installmentNo?.toString() === props.selectedInstallment),
)
</script>

<template>
    <div class="grid gap-1">
        <div>
            <div>
                <span class="heading-md">{{ polishCurrencyTransformer(selected?.installmentPrice) }}</span>
                <span class="paragraph-sm">
                    x {{ selected?.installmentNo }}
                    {{
                        getPolishGenitive(selected?.installmentNo, {
                            singular: 'rata',
                            plural2to4: 'raty',
                            plural5plus: 'rat',
                        })
                    }}
                </span>
            </div>

            <div v-if="selected?.initialPrice">
                <span class="bold-paragraph-lg"> + {{ polishCurrencyTransformer(selected?.initialPrice) }} </span>
                <span class="paragraph-sm"> płatne na start</span>
            </div>
        </div>

        <div v-if="selected?.hardwarePrice">
            <div v-if="selected.beforePromotionPrice && selected.beforePromotionPrice > selected.hardwarePrice">
                <span class="paragraph-xs">Razem za sprzęt po rabacie: </span>
                <span class="bold-paragraph-xs px-2xs !line-through">
                    {{ polishCurrencyTransformer(selected?.beforePromotionPrice) }}
                </span>

                <span class="bold-paragraph-xs bg-validation-success-light text-validation-success px-2xs">
                    {{ polishCurrencyTransformer(selected?.hardwarePrice) }}
                </span>
            </div>
            <div v-else>
                <span class="paragraph-xs">Razem za sprzęt: </span>
                <span class="bold-paragraph-xs"> {{ polishCurrencyTransformer(selected?.hardwarePrice) }}</span>
            </div>
        </div>

        <div v-if="selected?.omnibusPrice">
            <span class="paragraph-xs">Najniższa cena w ciągu 30 dni: </span>
            <span class="paragraph-xs">
                {{ polishCurrencyTransformer(selected?.omnibusPrice) }}
            </span>
        </div>
    </div>
</template>
